import { Box, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useDebounce } from "use-debounce";
import { CheckoutService } from "@/services/checkout/CheckoutService";
import { AD_BASIC_PACKAGE_CONFIG } from "@/sell/models/checkout/config/AdPackageConfig";
import PillButton from "@/app/shared/PillButton";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { CreateAdViewModel } from "@/sell/models/CreateAdViewModel";
import { AD_CONFIG_STATE_DEFAULTS } from "@/sell/models/AdConfigState";
import { useEffect } from "react";
import { CreateAnalyticEvent } from "@/actions/details/CreateAnalyticEvent";

export function AdCostMessage() {
  const {
    watch,
    formState: { isSubmitting, isValid },
  } = useFormContext<Required<CreateAdViewModel>>();
  const adDetails = watch("details");
  const vertical = watch("vertical");
  const adPackagePrice = isValid
    ? CheckoutService.GetAdPackagePrice({
        product: AD_BASIC_PACKAGE_CONFIG,
        config: AD_CONFIG_STATE_DEFAULTS,
        details: adDetails,
        vertical,
      })
    : undefined;
  const [adPackagePriceDebounced] = useDebounce(adPackagePrice, 500);
  const isLoading = adPackagePrice !== adPackagePriceDebounced;

  useEffect(() => {
    if (adPackagePriceDebounced !== undefined) {
      CreateAnalyticEvent({
        event: {
          adIds: ["NONE"],
          eventType: "AD_SELL#PRICING",
          metadata: {
            vertical,
            price: adPackagePriceDebounced,
          },
        },
      });
    }
  }, [adPackagePriceDebounced, vertical]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-end",
        gap: 2,
      }}
    >
      {!isLoading && isValid && (
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {adPackagePrice === 0 ? (
            <>start selling for free!</>
          ) : (
            <>create your ad from ${adPackagePrice} until sold</>
          )}
        </Typography>
      )}
      <PillButton
        endIcon={<NavigateNextIcon />}
        compactOnMobile
        primary
        type="submit"
        disabled={isSubmitting}
        loading={isLoading || isSubmitting}
      >
        Create Ad
      </PillButton>
    </Box>
  );
}
